<section class="find-recommend-partner-infomation-squidex">
  <ng-container *ngFor="let partner of ServiceList">
    <div class="box">
      <div class="box__left">
        <h1 class="box__heading--mw"><span [innerHTML]="partner.data.nameCompany?.iv"></span></h1>
        <h2 class="box__detail--mw"><span [innerHTML]="partner.data.goal?.iv"></span></h2>
      </div>

      <div class="box__right">
        <picture>
          <source [srcset]="partner.data.imageWebp.iv" type="image/webp" />
          <img
            [src]="partner.data.image.iv"
            loading="lazy"
            [alt]="partner.data.founder.iv"
            [title]="partner.data.founder.iv"
            class="box__image"
          />
        </picture>
      </div>
    </div>

    <div class="motto">
      <h2 class="motto__title desktop"
        >"<span>{{ partner.data.mottoLine1?.iv }}</span>
        <br *ngIf="partner.data.mottoLine2.iv" />
        <span>{{ partner.data.mottoLine2?.iv }}</span>
        <br *ngIf="partner.data.mottoLine3.iv" />
        <span>{{ partner.data.mottoLine3?.iv }}</span
        >"</h2
      >
      <div class="motto__title mobile"
        >"<span>{{ partner.data.mottoLine1?.iv }}</span>
        <span>{{ partner.data.mottoLine2?.iv }}</span>
        <span>{{ partner.data.mottoLine3?.iv }}</span
        >"</div
      >
    </div>

    <div class="card--wrapper">
      <div class="founder">
        <h3 class="founder__title"
          ><span>{{ 'NEW_ACCOUNTING_FIRM.RECOMMEND-PARTNER.INFORMATION.FOUNDER' | translate }}</span></h3
        >
        <h4 class="founder__detail"><span [innerHTML]="partner.data.founder?.iv"></span></h4
      ></div>
      <div class="beginningStory"
        ><h3 class="beginningStory__title"
          ><span>{{ 'NEW_ACCOUNTING_FIRM.RECOMMEND-PARTNER.INFORMATION.BEGINNINGSTORY' | translate }}</span></h3
        >
        <h4 class="beginningStory__detail"><span [innerHTML]="partner.data.beginningStory?.iv"></span></h4
      ></div>
      <div class="address">
        <h3 class="address__title"
          ><span>{{ 'NEW_ACCOUNTING_FIRM.RECOMMEND-PARTNER.INFORMATION.ADDRESS' | translate }}</span></h3
        >
        <h4 class="address__detail"><span [innerHTML]="partner.data.address?.iv"></span></h4
      ></div>
      <div class="concept">
        <h3 class="concept__title"
          ><span>{{ 'NEW_ACCOUNTING_FIRM.RECOMMEND-PARTNER.INFORMATION.CONCEPT' | translate }}</span></h3
        >
        <h4 class="concept__detail"><span [innerHTML]="partner.data.concept?.iv"></span></h4
      ></div>
    </div>

    <div class="contact-partner">
      <ng-container *ngIf="partner.data.fb.iv">
        <div class="icon-wrapper"
          ><i class="fab fa-facebook-square"></i
          ><a href="https://{{ partner.data.fb.iv }}" class="gray-line" target="_blank" rel="nofollow noopener">{{
            partner.data.fb.iv
          }}</a></div
        >
      </ng-container>
      <ng-container *ngIf="partner.data.tel.iv">
        <div class="icon-wrapper"
          ><i class="fas fa-phone"></i
          ><a href="tel:{{ partner.data.tel.iv }}" class="gray-line" target="_blank" rel="nofollow noopener">{{
            partner.data.tel.iv
          }}</a></div
        >
      </ng-container>
      <ng-container *ngIf="partner.data.website.iv">
        <div class="icon-wrapper"
          ><i class="fas fa-link"></i
          ><a href="https://{{ partner.data.website.iv }}" class="gray-line" target="_blank" rel="nofollow noopener">{{
            partner.data.website.iv
          }}</a></div
        >
      </ng-container>
    </div>
  </ng-container>
</section>
